import { useEffect } from 'react';

interface SalesPlansEffects {
  selectYearHandler(): void;
  getSalePlansHandler(): void;
}
export const useSalesPlansEffects = ({
  selectYearHandler,
  getSalePlansHandler,
}: SalesPlansEffects) => {
  useEffect(() => {
    selectYearHandler();
  }, [selectYearHandler]);

  useEffect(() => {
    getSalePlansHandler();
  }, [getSalePlansHandler]);
};
